/* eslint-disable */
/* eslint-disable react/prop-types */
import { FormControl, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import get from 'lodash/get';
import React from 'react';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

/**
 * AccountSwitcher
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const AccountSwitcher = ({ accounts, onChange, value, label, maxWidth, onClose, open }) => {
  const [defaultAccount] = accounts || [];
  const isEnabled = accounts && accounts.length > 0;
  if (!accounts) {
    return null;
  }
  if (accounts.length === 1) {
    return <Typography variant="body1" data-mf-replace-inner={MFSDR}>{accounts[0].accountName}</Typography>;
  }
  const props = {};

  if (maxWidth) {
    props.style = { maxWidth };
  }

  return (
    <FormControl {...props}>
      {label ? (
        <InputLabel htmlFor="accountSwitcherDropdown" shrink>
          {label}
        </InputLabel>
      ) : null}
      <Select
        data-mf-replace-inner={MFSDR}
        autoWidth
        disabled={!isEnabled}
        id="accountSwitcherDropdown"
        onChange={(event) => {
          const { value: selectedValue } = event.target || {};
          if (onChange) {
            onChange(selectedValue);
          }
        }}
        onClose={onClose}
        open={open}
        value={value || get(defaultAccount, `billTo`, ``)}
      >
        {accounts.map((account) => (
          <MenuItem key={account.billTo} value={account.billTo} data-mf-replace-inner={MFSDR}>
            {account.accountName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AccountSwitcher;
